'use strict';

angular.module('substoreApp.controllers')
    .controller('orderconfirmationController', OrderconfirmationController);

function OrderconfirmationController($scope, $routeParams, dialogData, sessionData, productDataCollector, optinProductTransformer, htmlTruster, webtrekk) {

    $scope.mode = { optin: ($routeParams.mode === "optin") ? true : undefined };
    $scope.confirmationInProgress = $routeParams.mode === "inProgress";

    $scope.progressBar.reset();

    $scope.isCatalogueActive = true;

    function initDialogData() {
        var data = $scope.data = dialogData;

        var keyword = $scope.mode.optin ? 'Optin' : $scope.confirmationInProgress  ? 'InProgress' : '';
        var product = optinProductTransformer.transform(productDataCollector.collect(data.product), keyword);

        $scope.breadcrumb.init(
            data.subscriptionBookedByExtern ? "navigation_myproducts" : "navigation_catalogue",
            data.subscriptionBookedByExtern ? "#/myproducts": "#/");
        $scope.breadcrumb.add(product.texts.productName, "#/productdetails/" + (product.productGroup || product.subscriptionTemplateId));
        $scope.breadcrumb.add("order");

        if (data.subscriptionBookedByExtern) {
            $scope.isCatalogueActive = false;
            $scope.isMyProductsActive = true;
        }

        // TODO mvz: Make the next two lines sense?? In the updateTeaser function title and subtitle will be overridden anyway.
        $scope.teaser.title = product.texts.headerTitleConfirmation && product.texts.headerTitleConfirmation.toLocaleUpperCase();
        $scope.teaser.subtitle = product.texts.headerSubTitleConfirmation && product.texts.headerSubTitleConfirmation.toLocaleUpperCase();

        $scope.updateTeaser(
            product.texts.headerTitleConfirmation,
            product.texts.headerSubTitleConfirmation,
            product.images.headerImageConfirmationResourcePath);

        $scope.progressBar.setup({
            step: 3,
            isOnlyReservationAllowed: data.isOnlyReservationAllowed,
            isPurchaseRedirectRequired: data.isPurchaseRedirectRequired,
            thirdPartyAuthentication: data.thirdPartyAuthentication,
            progressBarEnabled: data.progressBarEnabled,
            optin: $scope.mode.optin,
            hideSelection: dialogData.orderSelectionSkipped
        });

        htmlTruster.trust($scope.data.product);

        $scope.footnotes = product.productDescription.footnotes;

        webtrekk.track('order_confirmation', {
            shop_product_name: product.texts.productName,
            shop_product_quantity: "1",
            shop_product_sku: product.subscriptionTemplateId,
            shop_product_status: "conf",
            shop_order_value: sessionData.transient.priceValue,
            shop_order_id: sessionData.transient.uniqueSubscriptionId
        });
        sessionData.transient.priceValue = undefined;
        sessionData.transient.uniqueSubscriptionId = undefined;

    }

    initDialogData();
}